import { Grid, Button, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import getFormFieldInfo from '../../../../api/Purchasers/getFormFieldsInfo.api';
import getFormFieldDate from '../../../../api/Purchasers/getFormFieldsDate.api';
import signExtraDocument from '../../../../api/Purchasers/signExtraDocument.api';
import Modal from '../../../layout/modal/Modal';
import styles from './FormFieldModal.module.scss';
import dayjs from 'dayjs';
import CustomTextField from '../../../layout/customTextField/CustomTextField';
import _ from 'lodash';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../../redux/confirmations/actions';
import ConfirmationComponent from '../../../confirmation/ConfirmationComponent';
import { checkExtraFormInput } from '../../../../utils/validateForm';

const FormFieldmodal = ({
	// parent props
	clientInfo,
	formInfo,
	closeForm,
	// redux
	individualClients,
	leadId,
	coBrokers,
	salesAgents,
	modal,
	confirmation,
	setConfirmation,
	closeConfirmation,
}) => {
	const formsBySection = _(formInfo?.formItems)
		.filter((formObj) => _.has(formObj, 'section'))
		.groupBy('section')
		.value();
	const [formData, setFormData] = useState();
	const [formatedFormData, setFormatedFormData] = useState({});

	const onChange = (e) => {
		let name = e.target.name;
		let type = e.target.type;
		if (type === 'date') {
			setFormData({
				...formData,
				[name]: dayjs(e.target.value).format('YYYY-MM-DD'),
			});
			setFormatedFormData({
				...formatedFormData,
				[e.target.name]: dayjs(e.target.value).format('DD MMM YYYY'),
			});
		} else if (name === 'total_no_tax') {
		} else if (
			name === 'agent_name' &&
			formInfo?.subjectName === 'Cobroke Form'
		) {
			let agentObj = e.target.value;
			setFormData({
				...formData,
				[name]: agentObj,
				sales_agency: agentObj?.salesAgency,
				agent_email: agentObj?.email,
				agent_address: agentObj?.address,
				agent_phone: agentObj?.phoneNumber,
			});
		} else if (name === 'agent_name') {
			let agentObj = e.target.value;
			setFormData({
				...formData,
				[name]: agentObj,
				agent_email: agentObj?.salesAgentEmail,
			});
		} else {
			if (checkExtraFormInput(e.target.value, name)) {
				setFormData({
					...formData,
					[name]: e.target.value,
				});
			}
		}
	};

	const getFormFieldValue = (
		path,
		field,
		addToDate,
		value,
		useAddition,
		e
	) => {
		if (addToDate !== undefined && addToDate === true) {
			var valRetun = getFormFieldDate(leadId, value);
			console.log('RETURNED VALUE ' + valRetun);
			return valRetun;
		} else {
			var valRetun = getFormFieldInfo(leadId, path, useAddition);
			console.log('RETURNED VALUE ' + valRetun);
			return valRetun;
		}
	};

	useEffect(() => {
		// This useEffect will be used to calculate price, subtotal, total with tax for customer extra form
		let price_1 = Number(formData?.price_1);
		let price_2 = Number(formData?.price_2);
		let subTotal = (price_1 || 0) + (price_2 || 0);
		let hst = Number(formData?.hst) || 0;
		let totalWithTax = subTotal + subTotal * hst;
		setFormData({
			...formData,
			total_no_tax: subTotal,
			total_incl: totalWithTax,
		});
	}, [formData?.price_1, formData?.price_2, formData?.hst]);

	useEffect(() => {
		// This useEffect will be used to calculate total deposit for EFT form
		let deposit1 = Number(formData?.deposit_1) || 0;
		let deposit2 = Number(formData?.deposit_2) || 0;
		let deposit3 = Number(formData?.deposit_3) || 0;
		let deposit4 = Number(formData?.deposit_4) || 0;
		let deposit5 = Number(formData?.deposit_5) || 0;
		let deposit6 = Number(formData?.deposit_6) || 0;
		let total =
			deposit1 + deposit2 + deposit3 + deposit4 + deposit5 + deposit6;
		setFormData({
			...formData,
			total_deposit: total,
		});
	}, [
		formData?.deposit_1,
		formData?.deposit_2,
		formData?.deposit_3,
		formData?.deposit_4,
		formData?.deposit_5,
		formData?.deposit_6,
	]);

	useEffect(() => {
		if (modal === true) {
			// Prefill form data
			let formItems = formInfo?.formItems;
			let form = {};
			_.forEach(formItems, function (field) {
				if (field?.hasOwnProperty('autoFillInfo')) {
					const name = field?.customField;
					const value = getFormFieldValue(
						field?.autoFillInfo,
						field?.customField,
						field?.addToDate,
						field?.value,
						field?.useAddition
					);
					form[name] = value;
				}
			});
			setFormData(form);
		}
		return function cleanup() {
			if (modal !== true) {
				console.log('CLEAN UP');
			}
		};
	}, [modal]);
	const handleSignDocument = async (e) => {
		e.preventDefault();
		let secondClient;
		if (formInfo?.secondPurchaserTemplateId) {
			// Second client : Customer Extra Form, Amendment Ambria, EFT Ambria, Mutual Release
			if (formData?.second_name && formData?.second_email) {
				secondClient = {
					secondClientFullName: formData.second_name,
					secondClientEmail: formData.second_email,
				};
			}
		}
		let combinedForm = Object.assign(formData, formatedFormData);
		signExtraDocument(
			formInfo,
			combinedForm,
			leadId,
			clientInfo,
			secondClient,
			async (callback) => {
				if (callback) {
					setFormData();
					setFormatedFormData();
					await setConfirmation('completeExtraForm');
				}
			}
		);
	};
	const handleCloseConfirmation = () => {
		closeConfirmation('completeExtraForm');
		closeForm(leadId);
	};
	var buttonList = [
		{
			name: 'Done',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				backgroundColor: 'var(--primary)',
				color: 'var(--white)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<>
			<Modal
				show={modal}
				close={() => {
					setFormData();
					setFormatedFormData();
					closeForm(leadId);
				}}
				key={formInfo?.subjectName}
				title={formInfo?.subjectName}
				wrapperWidth={'95%'}
				wrapperMax={880}
			>
				<form
					id='client-extra-form'
					onSubmit={(e) => handleSignDocument(e)}
					className={styles.client_form}
					method='POST'
				>
					<Grid container className={styles.formFieldWrapper}>
						<Grid item xs={12} sm={6} className={styles.section}>
							<h5 className={styles.clientName}>
								{formData?.buyer_full_name}
							</h5>
							<p className={styles.clientInfo}>
								{formData?.client_email ||
									clientInfo?.clientEmail}
								&nbsp;|&nbsp;
								{clientInfo?.clientPhoneNumber}
							</p>
							{formData?.client_address && (
								<p className={styles.clientInfo}>
									{formData?.client_address}
								</p>
							)}
						</Grid>

						{_.size(individualClients) > 1 && (
							<Grid
								item
								xs={12}
								sm={6}
								className={styles.section}
							>
								{formData?.second_name && (
									<>
										<h5 className={styles.clientName}>
											{
												_.values(
													individualClients
												).pop()?.firstName
											}
											&nbsp;
											{
												_.values(
													individualClients
												).pop()?.lastName
											}
										</h5>
										<p className={styles.clientInfo}>
											{
												_.values(
													individualClients
												).pop()?.email
											}
											&nbsp;|&nbsp;
											{
												_.values(
													individualClients
												).pop()?.phoneNumber
											}
										</p>
									</>
								)}
							</Grid>
						)}

						<Grid item xs={12} className={styles.section}>
							{formData?.building_model_number && (
								<p className={styles.clientInfo}>
									Building Model&nbsp;:&nbsp;
									{formData.building_model_number}
								</p>
							)}
							{formData?.building_elevation && (
								<p className={styles.clientInfo}>
									Building Elevation&nbsp;:&nbsp;
									{formData.building_elevation}
								</p>
							)}
							{formData?.building_lot_number && (
								<p className={styles.clientInfo}>
									Lot&nbsp;
									{formData?.building_lot_number}
								</p>
							)}
							{formData?.display_price_number && (
								<p className={styles.clientInfo}>
									Total Home Price&nbsp;
									{formData?.display_price_number}
								</p>
							)}
						</Grid>
					</Grid>

					{_.keys(formsBySection)?.map((section, key) => {
						return (
							<Grid
								display='flex'
								flexDirection='row'
								container
								className={styles.formSection}
								style={{
									margin: '12px 0',
								}}
							>
								{formsBySection[section]?.map(
									(field, index) => {
										const characterLimit =
											Number(field?.charLimit) || 300;
										let char = _.size(
											formData?.[field?.customField]
										);
										if (field?.multiline === true) {
											return (
												<>
													<Grid
														item
														className={
															styles.formItem
														}
														xs={12}
														sm={6}
														key={index}
													>
														<CustomTextField
															formLabel={
																field?.title
															}
															placeholder={
																field?.title
															}
															name={
																field?.customField
															}
															value={
																(formData &&
																	formData[
																		field
																			?.customField
																	]) ||
																getFormFieldValue(
																	field?.autoFillInfo,
																	field?.customField,
																	field?.addToDate,
																	field?.value,
																	field?.useAddition
																) ||
																''
															}
															onChange={(e) =>
																onChange(e)
															}
															type={
																field?.fieldType
															}
															InputLabelProps={{
																shrink: true,
															}}
															multiline={true}
															charLimit={
																characterLimit
															}
															charLeft={char}
															required={
																field.required ===
																true
																	? true
																	: false
															}
														/>
													</Grid>
												</>
											);
										} else if (
											field?.customField ===
												'agent_name' &&
											formInfo?.subjectName ==
												'Cobroke Form'
										) {
											return (
												<>
													<Grid
														item
														className={
															styles.formItem
														}
														xs={12}
														sm={6}
														key={index}
													>
														<CustomTextField
															formLabel={
																field?.title
															}
															name={
																field?.customField
															}
															value={
																(formData &&
																	formData[
																		field
																			?.customField
																	]) ??
																''
															}
															required={
																field.required ===
																true
																	? true
																	: false
															}
															onChange={(e) =>
																onChange(e)
															}
															type={
																field?.fieldType
															}
															placeholder={
																field?.title
															}
															select
															SelectProps={
																formData?.[
																	field
																		?.customField
																] === ''
																	? {
																			style: {
																				backgroundColor:
																					'white',
																				color: '#979797',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																			displayEmpty: true,
																			renderValue:
																				() =>
																					`Select ${field?.title}`,
																	  }
																	: {
																			style: {
																				backgroundColor:
																					'none',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																	  }
															}
															menulistprops={{
																disablePadding: true,
															}}
															autoComplete='off'
														>
															<MenuItem
																disabled
																value=''
															>
																Select{' '}
																{field?.title}
															</MenuItem>
															{coBrokers?.map(
																(cobroker) => (
																	<MenuItem
																		value={
																			// cobroker.coBrokerId
																			cobroker
																			// salesAgent
																		}
																		key={
																			cobroker.coBrokerId
																		}
																	>
																		{
																			cobroker.name
																		}
																	</MenuItem>
																)
															)}
														</CustomTextField>
													</Grid>
												</>
											);
										} else if (
											field?.customField === 'agent_name'
										) {
											return (
												<>
													<Grid
														item
														className={
															styles.formItem
														}
														xs={12}
														sm={6}
														key={index}
													>
														<CustomTextField
															formLabel={
																field?.title
															}
															name={
																field?.customField
															}
															value={
																(formData &&
																	formData[
																		field
																			?.customField
																	]) ??
																''
															}
															// required
															onChange={(e) =>
																onChange(e)
															}
															type={
																field?.fieldType
															}
															placeholder={
																field?.title
															}
															select
															SelectProps={
																formData?.[
																	field
																		?.customField
																] === ''
																	? {
																			style: {
																				backgroundColor:
																					'white',
																				color: '#979797',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																			displayEmpty: true,
																			renderValue:
																				() =>
																					`Select ${field?.title}`,
																	  }
																	: {
																			style: {
																				backgroundColor:
																					'none',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																	  }
															}
															menulistprops={{
																disablePadding: true,
															}}
															autoComplete='off'
															required={
																field.required ===
																true
																	? true
																	: false
															}
														>
															<MenuItem
																disabled
																value=''
															>
																Select{' '}
																{field?.title}
															</MenuItem>
															{salesAgents?.map(
																(
																	salesAgent
																) => (
																	<MenuItem
																		value={
																			salesAgent
																		}
																		key={
																			salesAgent.salesAgentId
																		}
																	>
																		{
																			salesAgent.salesAgentName
																		}
																	</MenuItem>
																)
															)}
														</CustomTextField>
													</Grid>
												</>
											);
										} else if (
											field?.fieldType === 'select'
										) {
											return (
												<>
													<Grid
														item
														className={
															styles.formItem
														}
														xs={12}
														sm={6}
														key={index}
													>
														<CustomTextField
															formLabel={
																field?.title
															}
															name={
																field?.customField
															}
															value={
																(formData &&
																	formData[
																		field
																			?.customField
																	]) ??
																''
															}
															onChange={(e) =>
																onChange(e)
															}
															type={
																field?.fieldType
															}
															placeholder={
																field?.title
															}
															select
															SelectProps={
																!formData?.[
																	field
																		?.customField
																]
																	? {
																			style: {
																				backgroundColor:
																					'white',
																				color: '#979797',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																			displayEmpty: true,
																			renderValue:
																				() =>
																					'Select HST',
																	  }
																	: {
																			style: {
																				backgroundColor:
																					'none',
																				'&.MuiSelectSelect:focus':
																					{
																						backgroundColor:
																							'white',
																					},
																			},
																			MenuProps:
																				{
																					menulistprops:
																						{
																							disablePadding: true,
																						},
																				},
																	  }
															}
															menulistprops={{
																disablePadding: true,
															}}
															autoComplete='off'
															required={
																field.required ===
																true
																	? true
																	: false
															}
														>
															<MenuItem
																disabled
																value=''
															>
																Select{' '}
																{field?.title}
															</MenuItem>
															{field?.selectItems?.map(
																(item) => (
																	<MenuItem
																		key={
																			item.id
																		}
																		className={
																			styles.idTypeItem
																		}
																		value={
																			item.id
																		}
																	>
																		{
																			item.name
																		}
																	</MenuItem>
																)
															)}
														</CustomTextField>
													</Grid>
												</>
											);
										} else if (field?.readOnly === true) {
											return (
												<Grid
													item
													className={
														styles.formItem_rightAlign
													}
													xs={12}
													sm={6}
													key={index}
													style={{
														marginLeft:
															'auto !important',
													}}
												>
													<CustomTextField
														formLabel={field?.title}
														placeholder={
															field?.title
														}
														name={
															field?.customField
														}
														value={
															(formData &&
																formData[
																	field
																		?.customField
																]) ||
															''
														}
														// value={() =>
														// 	getTotalPrice(
														// 		field?.customField
														// 	)
														// }
														type={field?.fieldType}
														inputProps={{
															shrink: true,
															readOnly: true,
														}}
														readOnly={true}
														// className={styles.addDocField}
														// fullWidth
													/>
												</Grid>
											);
										} else if (
											field?.hasOwnProperty('fieldType')
										) {
											return (
												<>
													<Grid
														item
														className={
															styles.formItem
														}
														xs={12}
														sm={6}
														key={index}
													>
														<CustomTextField
															formLabel={
																field?.title
															}
															placeholder={
																field?.title
															}
															name={
																field?.customField
															}
															value={
																(formData &&
																	formData[
																		field
																			?.customField
																	]) ||
																getFormFieldValue(
																	field?.autoFillInfo,
																	field?.customField,
																	field?.addToDate,
																	field?.value,
																	field?.useAddition
																) ||
																''
															}
															onChange={(e) =>
																onChange(e)
															}
															type={
																field?.fieldType
															}
															inputProps={{
																shrink: true,
															}}
															required={
																field.required ===
																true
																	? true
																	: false
															}
														/>
													</Grid>
												</>
											);
										}
									}
								)}
							</Grid>
						);
					})}

					<div className={styles.btnWrapper}>
						<Button
							className={styles.btn_cancel}
							onClick={() => {
								setFormData();
								setFormatedFormData();
								closeForm(leadId);
							}}
						>
							Cancel
						</Button>
						<Button
							className={styles.addBtn}
							variant='contained'
							// onClick={() => handleSignDocument()}
							type='submit'
						>
							Create Agreement
						</Button>
					</div>
				</form>
			</Modal>
			<ConfirmationComponent
				open={confirmation?.completeExtraForm}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
				styledConfirmation={true}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	modal: state.modals.docFormField,
	leadId: state.purchasers.purchaserById.leadId,
	individualClients: state.agreement?.agreementById?.clientInfo?.individual,
	coBrokers: state.siteplanManagement?.coBrokers,
	salesAgents: state.siteplanManagement?.salesAgents,
	confirmation: state.confirmation,
});

export default connect(mapStateToProps, {
	setConfirmation,
	closeConfirmation,
})(FormFieldmodal);
